module.exports = __webpack_public_path__ + "img/inspection_m.c2d3f4ca.jpg";